import type { IconName } from '@festina-life/ui/structure'

import type { UserActionData } from '../../uiModels/types'

export const UserActionIcon: Record<UserActionData['action'], IconName> = {
  create: 'DocumentPlus',
  approve: 'CheckCircle',
}
